import React, { useEffect, useRef } from "react";
import { useState } from "react";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import DocumentItems from "./documentItems"
import { getKarzaVehicleData } from "../../../services/Store/Actions/fleetActions";
import PermitItems from "./permitItems";
import AddEditDocModal from "./addEditDocModal";

function DocumentsAndPermits(props) {
    const { vehicleDocsData} = props
    let { id } = useParams();
    const fleetId = id
    const dispatch = useDispatch();

    const { advancedVehicleList } = useSelector(
      (state) => state?.fleet
    );
    const vehicle = advancedVehicleList?.filter(
      (element) => element.fleetId == fleetId
    )[0];
    
    console.log("vehicle", vehicle, fleetId);
    const [create, setCreate] = useState(false);
    const toggleCreate = () => {
        setCreate(!create)
    }
    const [rawImage, setRawImage] = useState('')

    const DocsData = {
        101: "Registration Certificate",
        102: "Insurance",
        103: "Pollution",
        104: "National Permit",
        105: "Road Tax",
        106: "Fitness",
    }
    useEffect(() => {
        dispatch(getKarzaVehicleData({fleetId: fleetId}, (res)=> {
            console.log("dispatchgetKarzaVehicleData", res);
        }));
      }, []);
    const karzaVehicleData = useSelector((state) => state?.fleet?.karzaVehicleData);

console.log("getKarzaVehicleData",karzaVehicleData ,vehicleDocsData);
const permits = []
vehicleDocsData.forEach(doc => {if(doc.expenseType == 111)  permits.push(doc)})
console.log(permits,"permitspermitspermits");
return ( 
    <div>
        <div>
            {Object.keys(DocsData).map((elem, i) => {
                return (<DocumentItems 
                        type={elem}
                        value={DocsData[elem]}
                        data={vehicleDocsData.find(doc => doc.expenseType == elem)}
                        fleetId={fleetId}
                        vehicleData={karzaVehicleData}
                    />)
                })
            }
        </div>
    
    <div>

        {permits.length>0 ? permits.map((elem, i) => {
            return (<PermitItems 
                    type={111}
                    value={JSON.parse(elem.remarks).Type}
                    data={elem}
                    fleetId={fleetId}
                />)
            }): <></>}
       
    </div>
    <div style={{display: "flex", justifyContent:"center", marginTop:"10px",  paddingBottom:"100px"}}>
        <button
            className="activeTab" style={{border: "1px solid grey", borderRadius: "5px", height: "40px"}} 
            onClick={()=>{setCreate(true)}}>
                Add New Document
          </button>
        
    </div>
    {create ? <AddEditDocModal 
            toggle={toggleCreate} 
            modal={create}
            setModal={setCreate} 
            isEdit={false} 
            fleetId={fleetId}
            type={111}
            rawImage={rawImage}
            setRawImage={setRawImage}
        /> : <></>}
        
    </div>
    )
}
export default DocumentsAndPermits;
